import LocalStorageService from '../services/LocalStorageService'
import ApiService from './ApiService'
const apiToken = LocalStorageService.get('apiToken')

class NotificationRuleService {

  async getRules() {
    let url = '/api/notification/rule'
    let params = {}
    let body = {}

    try {
      const response = await ApiService.get(apiToken, url, params, body)
      console.log("Fetched notification rules:", response)
      return response
    } catch (err) {
      console.error(err)
    }
  }

  async updateRules(rules) {
    const url = '/api/notification/rule'
    const params = {}
    const body = { rules }

    try {
      return await ApiService.post(apiToken, url, params, body)
    } catch (err) {
      console.error(err)
      return { error: err.message }
    }
  }

}
export default new NotificationRuleService()
